import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type {
  CustomerContactFilters,
  CustomerContactSlice,
} from "./customerContactsTypes.ts";

const initialState: CustomerContactSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "id",
    order: "asc",
  },
};

export const customerContactsSlice = createSlice({
  name: "customerContacts",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<CustomerContactSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<CustomerContactSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [
          filterType: keyof CustomerContactFilters,
          filterValue: string | undefined,
        ]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<CustomerContactSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  customerContactsSlice.actions;

export const selectPage = (state: RootState) => state.customerContacts.page;

export const selectRowsPerPage = (state: RootState) =>
  state.customerContacts.rowsPerPage;

export const selectFilter = (state: RootState) => state.customerContacts.filter;

export const selectSort = (state: RootState) => state.customerContacts.sort;

export default customerContactsSlice.reducer;
